/*
 * Jira Ticket:
 * Created Date: Mon, 20th Apr 2020, 15:04:07 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const acceptSubcontractMutation = gql`
  mutation acceptSubcontract($id: ID!) {
    data: acceptSubcontract(id: $id) {
      id
    }
  }
`;

export default ({ client, params }) => {
  try {
    return client.mutate({
      mutation: acceptSubcontractMutation,
      variables: {
        ...params,
      },
    });
  } catch (e) {
    if (e.graphQLErrors && e.graphQLErrors.length) {
      const [error] = e.graphQLErrors;
      const message = error.message;
      throw new Error(message);
    }
    throw e;
  }
};
